export enum UserRole {
  Admin = 'Admin',
  InputAdmin = 'Input Admin',
}

export default {};
